import {
  SET_OPEN_AVIALABILITY_MODAL,
  FOCUS_UNIT,
  SET_GEO_CITY,
  SET_EMERGENCY_MESSAGE,
  SET_PAGE_REQUEST_FIBRESTREAM,
  SET_PREVIOUS_PATHNAME
} from "../actions/app";

const initialState = {
  openAvailabilityModal: false,
  signupClicked: 0,
  geoCity: null,
  emergencyMessage: null,
  isPageRequestFibreStream: false,
  prevPathname: null
};

const app = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPEN_AVIALABILITY_MODAL:
      return { ...state, openAvailabilityModal: action.payload };
    case FOCUS_UNIT:
      return { ...state, signupClicked: state.signupClicked + 1 };
    case SET_GEO_CITY:
      return { ...state, geoCity: action.payload };
    case SET_EMERGENCY_MESSAGE:
      return { ...state, emergencyMessage: action.payload };
    case SET_PAGE_REQUEST_FIBRESTREAM:
      return { ...state, isPageRequestFibreStream: action.payload };
    case SET_PREVIOUS_PATHNAME:
      return { ...state, prevPathname: action.payload };
    default:
      return state;
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/reducers/app.js